import React, { useState } from "react";
import SubmitButton from "../../submitButton/submitButton";
import ErrorMessage from "../../errorMessage/errorMessage";
import { required, maxLength1000 } from "../../formHelpers/validationFunctions";

const OrganizationForm = ({ onSubmit, initialValues = {}, loading }) => {
  const [formData, setFormData] = useState({
    title: initialValues.title || "",
    description: initialValues.description || "",
  });

  const [touched, setTouched] = useState({
    title: false,
    description: false,
  });

  const [errors, setErrors] = useState({
    title: "",
    description: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Validate on change if field has been touched
    if (touched[name]) {
      validateField(name, value);
    }
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    setTouched((prev) => ({
      ...prev,
      [name]: true,
    }));
    validateField(name, value);
  };

  const validateField = (name, value) => {
    let error = "";

    if (name === "title") {
      error = required(value) || "";
    } else if (name === "description") {
      error = maxLength1000(value) || "";
    }

    setErrors((prev) => ({
      ...prev,
      [name]: error,
    }));

    return error;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Touch all fields
    setTouched({
      title: true,
      description: true,
    });

    // Validate all fields
    const titleError = validateField("title", formData.title);
    const descriptionError = validateField("description", formData.description);

    // Only submit if no errors
    if (!titleError && !descriptionError) {
      onSubmit({
        ...initialValues, // Include uuid if it exists
        title: formData.title,
        description: formData.description,
      });
    }
  };

  const isSubmitDisabled =
    loading || !formData.title || !!errors.title || !!errors.description;

  return (
    <form onSubmit={handleSubmit}>
      <div>
        <div className="form-field">
          <input
            className="body_field"
            name="title"
            type="text"
            placeholder="Enter the title of your organization"
            value={formData.title}
            onChange={handleChange}
            onBlur={handleBlur}
            disabled={loading}
          />
          {touched.title && errors.title && (
            <ErrorMessage message={errors.title} />
          )}
        </div>

        <div className="form-field" style={{ marginTop: 20 }}>
          <textarea
            className="body_field"
            name="description"
            placeholder="Enter a short description for your organization"
            value={formData.description}
            onChange={handleChange}
            onBlur={handleBlur}
            disabled={loading}
            rows={4}
            style={{ height: 200 }}
          />
          {touched.description && errors.description && (
            <ErrorMessage message={errors.description} />
          )}
        </div>
      </div>

      <div style={{ textAlign: "center" }}>
        <SubmitButton
          disabled={isSubmitDisabled}
          title="SUBMIT"
          position="right"
          classname="org-submit-button btn"
        />
      </div>
    </form>
  );
};

export default OrganizationForm;
